import { getAllUsersAssociatedWithAGroupV2 } from './API';


const GetAllUsersAssociatedWithAGroup = async (accessToken, exportFlag, selectedGroupIds) => {
    try {
      const { data } = await getAllUsersAssociatedWithAGroupV2(accessToken);
      if(exportFlag){
        const users = data.filter(group => selectedGroupIds.some(g => group.id === g.group.id)).map(userInGroup => userInGroup.users.filter(u => !u.status).map(user => 
            ({
              'Full Name': user.fullName,
              'Group Name': user.groupName,
              'Email Address': user.emailAddress,
              'Default Role': user.roleName
            })
        ))

        return { success: true, data: users.flat() };
      } else {
        const users = data;
        if(users.length === 0){
          return { success: false, data: 'No users found.' };
        }
        return { success: true, data: users};
      }
    } catch (error) {
      console.log('Error getting users data: ', error);
      return { success: false, data: error.response?.data.message ?  error.response?.data.message : 'Error'};
    }
  };
  
  export default GetAllUsersAssociatedWithAGroup;